module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=MY - Malaysia.069f0d41.svg";